"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrSetSessionId = void 0;
const uid_1 = require("uid");
const session_id_key = "sessionId";
const getOrSetSessionId = () => {
    const sessionId = sessionStorage.getItem(session_id_key);
    if (sessionId) {
        return sessionId;
    }
    const newSessionId = (0, uid_1.uid)(16);
    sessionStorage.setItem(session_id_key, newSessionId);
    return newSessionId;
};
exports.getOrSetSessionId = getOrSetSessionId;
//# sourceMappingURL=session-id.js.map